import React from 'react'
import { colors } from '../../../styles/vars/colors.style'

const LogoCircle = ({
  width = 130,
  height = 130,
  stroke = colors.light,
  responsive = false,
  offset = false,
  pathLength = 402,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 130 130"
      focusable="false"
      role="img"
      {...svgAttributes}
    >
      <circle
        cx={65}
        cy={65}
        fill="none"
        r={64}
        stroke={stroke}
        strokeWidth={1}
        strokeDashoffset={pathLength}
        strokeDasharray={pathLength}
        ref={forwardRef}
      />
    </svg>
  )
}

export default LogoCircle
